import { useLocalStorage } from '@vueuse/core'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useSidebarStore = defineStore('sidebarStore', () => {
  // Desktop rail: collapsed/expanded, persisted across sessions.
  const isExpanded = useLocalStorage<boolean>('sidebar_expanded', true)

  const widthClass = computed(() => (isExpanded.value ? 'w-[220px]' : 'w-16'))

  const toggle = () => {
    isExpanded.value = !isExpanded.value
  }

  // Mobile off-canvas drawer: never persisted (must start closed on load).
  const isMobileOpen = ref(false)

  const openMobile = () => {
    isMobileOpen.value = true
  }
  const closeMobile = () => {
    isMobileOpen.value = false
  }
  const toggleMobile = () => {
    isMobileOpen.value = !isMobileOpen.value
  }

  return { isExpanded, widthClass, toggle, isMobileOpen, openMobile, closeMobile, toggleMobile }
})
